import moment from 'moment';

const structureNodeData = (data, single = false) => {
  if (data.length === 0) return data;
  let structuredData = [];

  structuredData = data.map((dataItem, index) => ({ ...dataItem, id: index }));
  if (!single) {
    structuredData = structuredData.map((dataItem) => ({
      ...dataItem,
      dslectura: Math.round(Number(dataItem.dslectura)),
    }));
  }
  return structuredData;
};

const formatDates = (dateToFormat) => {
  return dateToFormat ? moment(dateToFormat).format('Y-MM-DD HH:mm') : moment().format('Y-MM-DD HH:mm');
};

export default {
  structureNodeData,
  formatDates,
};

// const structureNodeData = (data, single = false) => {
//   let structuredData = [];
//   let index = 1;
//   while (index < 11) {
//     if (!data[`dsnodo${index}`]) break;
//     structuredData = structuredData.concat({
//       dsnodo: data[`dsnodo${index}`],
//       id: index,
//     });
//     index += 1;
//   }
//   if (!single) {
//     structuredData = structuredData.map((dataItem, itemIndex) => ({
//       ...dataItem,
//       dslectura: Math.round(Number(data[`dslectura${itemIndex + 1}`])),
//     }));
//   }
//   return structuredData;
// };

// export default structureNodeData;